import { spotlightSplitWithMetrics } from "@redotech/redo-model/spotlight-schema";
import * as z from "zod/v4";

export const getSpotlightSplits = {
  name: "getSpotlightSplits" as const,
  input: z.object({}),
  output: z.array(spotlightSplitWithMetrics),
};
